import Button from 'components/new-ui/base/button/Button';
import { StyledTag } from 'components/new-ui/base/tag/styles';
import { JOB_STATUS_COLOR_MAP } from 'store/jobs/utils';
import { JobStatuses } from 'store/jobs/job';
import { JobAppliedParams } from '../useJobsParams';

type Props = {
    tags: any[];
    clearFilter: (key: string, value?: string) => void;
    clearAll: () => void;
};

const AppliedJobFilters = ({ tags, clearFilter, clearAll }: Props) => {
    return (
        <>
            {tags.map((t) => {
                if (t.key === JobAppliedParams.STATUS) {
                    const label = JOB_STATUS_COLOR_MAP[t.value as JobStatuses].label;
                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                clearFilter(t.key, t.value);
                            }}
                        >
                            {label}
                        </StyledTag>
                    );
                }

                if (t.key === JobAppliedParams.INCOTERM_CODE) {
                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                clearFilter(t.key);
                            }}
                        >
                            Delivery Terms - {t.value}
                        </StyledTag>
                    );
                }

                return (
                    <StyledTag
                        key={`${t.key}-${t.value}`}
                        closable
                        onClose={(e) => {
                            e.preventDefault();
                            clearFilter(t.key);
                        }}
                    >
                        {t.value}
                    </StyledTag>
                );
            })}

            {tags?.length > 0 && (
                <Button type="link" onClick={clearAll}>
                    Clear All Filters
                </Button>
            )}
        </>
    );
};

export default AppliedJobFilters;
